import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { AtwUpdateDbComponent } from 'vhobjects-service';  
import { FunctionService  } from 'vhobjects-service';
import { AtwTextParagraphAdmin } from '../../admin/text-paragraph/text-paragraph-admin.component';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { AtwTextParagraphAdmin } from '../../admin/text-paragraph/text-paragraph-admin.component';

@Component({
  selector: 'atw-text-paragraph-admin-config',
  templateUrl: './text-paragraph-admin-config.component.html',
  styleUrls: ['./text-paragraph-admin-config.component.scss']
})
export class AtwTextParagraphAdminConfig extends AtwUpdateDbComponent {
  /** object đang chọn */
  @Input() objectChoosing: any;
  /** Thiết bị hiện tại (desktop, tablet_portrait, tablet_landscape, mobile_portrait, mobile_landscape) */
  @Input() device: any;
  /** Dữ liệu class của thiết bị hiện tại */
  @Input() class: any;
  /** Dữ liệu config của thiết bị hiện tại */
  @Input() config: any;
  /** Dữ liệu staticdata */
  @Input() staticdata: any;
  /** Dữ liệu blocks_of_page */
  @Input() blocks_of_page: any;
  /** Loại trang (page, admin, ...) */
  @Input() type: any;

  configMode: 'basic' | 'advanced' = 'basic';

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 1,
    },
  ];
  customize = [];
  effect_hover = [];
  effect_hover_data: any = {};


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator, 
    public functionService: FunctionService, 
    private dialog: MatDialog,
    private http: HttpClient,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit() {
    // Nếu chưa có config thì khởi tạo config do mới thêm config này
    if (!this.config['-webkit-scrollbar']) {
      this.config['-webkit-scrollbar'] = {
        "width": "10px",
        "background-color": "#e7e7e7",
        "thumb-background-color": "#666666",
        "border-radius": "8px"
      };
    }

    if (!this.config['animation-selected']?.id) {
      this.config['animation-selected'] = {
        id: '000000',
      }
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/short-description.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  handleEdit() {
    const dialogRef = this.dialog.open(AtwTextParagraphAdmin, {
      width: '70vw',
      height: '90vh',
      disableClose: true,
      data: {
          data: this.objectChoosing,
      }

    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0]);
  }
}
